import { ReviewsViewModel, UserReviewViewModel } from 'models/hotel';

import { FindAnswersSearch, Reviews } from '__generated__/api';
import { mapUserReview } from './user-review-adapter';

import ReviewInfo = Reviews.ReviewInfo;
import FindAnswerReviewInfo = FindAnswersSearch.ReviewInfo;

export const mapReviews = (currentStore: ReviewsViewModel, response: ReviewInfo, totalRequested?: number): ReviewsViewModel => {
  const userReviews: UserReviewViewModel[] = response.reviews.map(mapUserReview);
  const {
    totalCount,
    reviewCountLocalized,
    averageOverallRating,
    cleanliness,
    cleanlinessOverMax,
    serviceAndStaff,
    amenityScore,
    hotelCondition,
    superlative,
    cleanlinessPercent,
    serviceAndStaffPercent,
    serviceAndStaffOverMax,
    amenityScorePercent,
    amenityScoreOverMax,
    hotelConditionPercent,
    hotelConditionOverMax,
    lastIndex,
    ratingCounts,
    reviewDisclaimer
  } = response.summary;

  currentStore.count = totalCount.raw;
  currentStore.localizedCount = totalCount.formatted;
  currentStore.localizedCountWithLabel = reviewCountLocalized;

  currentStore.overallRating = averageOverallRating.raw;
  currentStore.localizedOverallRating = averageOverallRating.formatted;

  currentStore.cleanliness = cleanliness.raw;
  currentStore.cleanlinessPercent = cleanlinessPercent;
  currentStore.localizedCleanliness = cleanliness.formatted;
  currentStore.cleanlinessOverMax = cleanlinessOverMax;

  currentStore.serviceAndStaff = serviceAndStaff.raw;
  currentStore.serviceAndStaffPercent = serviceAndStaffPercent;
  currentStore.localizedServiceAndStaff = serviceAndStaff.formatted;
  currentStore.serviceAndStaffOverMax = serviceAndStaffOverMax;

  currentStore.amenityScore = amenityScore.raw;
  currentStore.amenityScorePercent = amenityScorePercent;
  currentStore.localizedAmenityScore = amenityScore.formatted;
  currentStore.amenityScoreOverMax = amenityScoreOverMax;

  currentStore.hotelCondition = hotelCondition.raw;
  currentStore.hotelConditionPercent = hotelConditionPercent;
  currentStore.localizedHotelCondition = hotelCondition.formatted;
  currentStore.hotelConditionOverMax = hotelConditionOverMax;

  currentStore.superlative = superlative;

  currentStore.lastIndex = lastIndex;

  currentStore.ratingCounts = ratingCounts;

  if (!currentStore.userReviews) {
    currentStore.userReviews = [];
  }

  currentStore.userReviews.push(...userReviews);
  currentStore.totalReviewsRequested = totalRequested;
  currentStore.reviewDisclaimer = reviewDisclaimer;

  return currentStore;
};

export const mapFindAnswerReviews = (
  currentStore: ReviewsViewModel,
  response: FindAnswerReviewInfo,
  totalRequested?: number
): ReviewsViewModel => {
  const userReviews: UserReviewViewModel[] = response.reviews.map(mapUserReview);
  const {
    totalCount,
    averageOverallRating,
    cleanliness,
    serviceAndStaff,
    amenityScore,
    hotelCondition,
    superlative,
    cleanlinessPercent,
    serviceAndStaffPercent,
    amenityScorePercent,
    hotelConditionPercent,
    lastIndex,
    ratingCounts
  } = response.summary;

  currentStore.count = totalCount.raw;
  currentStore.localizedCount = totalCount.formatted;

  currentStore.overallRating = averageOverallRating.raw;
  currentStore.localizedOverallRating = averageOverallRating.formatted;

  currentStore.cleanliness = cleanliness.raw;
  currentStore.cleanlinessPercent = cleanlinessPercent;
  currentStore.localizedCleanliness = cleanliness.formatted;

  currentStore.serviceAndStaff = serviceAndStaff.raw;
  currentStore.serviceAndStaffPercent = serviceAndStaffPercent;
  currentStore.localizedServiceAndStaff = serviceAndStaff.formatted;

  currentStore.amenityScore = amenityScore.raw;
  currentStore.amenityScorePercent = amenityScorePercent;
  currentStore.localizedAmenityScore = amenityScore.formatted;

  currentStore.hotelCondition = hotelCondition.raw;
  currentStore.hotelConditionPercent = hotelConditionPercent;
  currentStore.localizedHotelCondition = hotelCondition.formatted;

  currentStore.superlative = superlative;

  currentStore.lastIndex = lastIndex;

  currentStore.ratingCounts = ratingCounts;

  if (!currentStore.userReviews) {
    currentStore.userReviews = [];
  }

  currentStore.userReviews.push(...userReviews);
  currentStore.totalReviewsRequested = totalRequested;

  return currentStore;
};
